import { insertarFactura } from "../infrastructure/supabase/supabaseFactura.js";
import { insertarVenta } from "../infrastructure/supabase/supabaseVentas.js";
import { insertarDetalleVenta } from "../infrastructure/supabase/supabaseDetalle.js";

import { construirCancelacion } from "../domain/entities/VentaCancelada.js";
import { construirDetalle } from "../domain/entities/DetalleVenta.js";

export async function cancelarFacturaUseCase({ factura }) {
  if (!factura) throw new Error(" [cancelarFacturaUseCase] Factura inválida");

  // 1️⃣ FACTURA CANCELADA
  const facturaBD = await insertarFactura({
    ...factura,
    estado: "cancelada",
  });

  if (!facturaBD?.idFactura) {
    throw new Error("[cancelarFacturaUseCase] ID de factura requerido");
  }

  // 2️⃣ VENTAS + DETALLES (MISMO FLUJO)
  for (const pedido of factura.pedidos) {
    const venta = construirCancelacion({
      mesaId: pedido.mesaId,
      total: pedido.total,
 
    });

    const ventaBD = await insertarVenta({
      id_factura: facturaBD.idFactura,
      venta,
    });

    for (const producto of pedido.productos) {
      const detalle = construirDetalle({ producto });

      await insertarDetalleVenta({
        id_venta: ventaBD.id_venta,
        detalle,
      });
    }
  }

  return facturaBD;
}
